"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTop = void 0;
var react_1 = __importDefault(require("react"));
var AppTopStyles_1 = require("./AppTopStyles");
var cs_logo_white_svg_1 = __importDefault(require("../../assets/images/cs_logo_white.svg"));
var lr_logo_bg_svg_1 = __importDefault(require("../../assets/images/lr_logo_bg.svg"));
var beko_white_01_svg_1 = __importDefault(require("../../assets/images/beko_white_01.svg"));
var testo_svg_1 = __importDefault(require("../../assets/images/testo.svg"));
var ipf_logo_bg_svg_1 = __importDefault(require("../../assets/images/ipf_logo_bg.svg"));
var core_1 = require("@material-ui/core");
var AppTop_styles_1 = require("./AppTop.styles");
exports.AppTop = react_1.default.memo(function (_a) {
    var children = _a.children, onLogoClick = _a.onLogoClick;
    var classes = AppTopStyles_1.useStyles();
    var theme = core_1.useTheme();
    var logo = cs_logo_white_svg_1.default;
    if (theme.mixins.themeStyle.theme === 'neutralLight') {
        logo = lr_logo_bg_svg_1.default;
    }
    if (theme.mixins.themeStyle.theme === 'bekoLight') {
        logo = beko_white_01_svg_1.default;
    }
    if (theme.mixins.themeStyle.theme === 'testoLight') {
        logo = testo_svg_1.default;
    }
    if (theme.mixins.themeStyle.theme === 'ipfLight') {
        logo = ipf_logo_bg_svg_1.default;
    }
    var icon = function () {
        if (theme.mixins.themeStyle.theme === 'ipfLight') {
            return (react_1.default.createElement("img", { src: logo, onClick: onLogoClick, style: __assign(__assign({}, AppTop_styles_1.appTopLogo), { paddingTop: '5px' }), alt: "logo", height: "30px" }));
        }
        return (react_1.default.createElement("img", { src: logo, onClick: onLogoClick, style: __assign(__assign({}, AppTop_styles_1.appTopLogo), { paddingTop: '5px' }), alt: "logo", height: "50px" }));
    };
    return (react_1.default.createElement("div", { className: classes.appTop, style: { backgroundColor: theme.mixins.themeStyle.appBarColor } },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 5 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 2, style: AppTop_styles_1.appTopMain },
                react_1.default.createElement("div", null, icon())),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 5, style: __assign({ paddingRight: 60 }, AppTop_styles_1.appTopAdditional) }, children !== null && children !== void 0 ? children : react_1.default.createElement(react_1.default.Fragment, null)))));
});
exports.AppTop.displayName = 'AppTop';
exports.default = exports.AppTop;
//# sourceMappingURL=AppTop.js.map